import { Overrides } from '@material-ui/core/styles/overrides'

const cardOverride: Overrides = {
  MuiCard: {
    root: {
      borderRadius: '14px',
    },
  },
}

export const masmovilCard = {
  mainColor: '#FFF4A6',
  backgroundColor: '#FEFBE4',
}

export const llamayaCard = {
  mainColor: '#EFD1F4',
  backgroundColor: '#FAF1FC',
}

export default cardOverride
